/**
 * Libertify Design System - Colors
 * Extracted from Figma Design System
 */

export const colors = {
  // Brand Colors - Primary (Teal/Turquoise)
  primary: {
    100: '#d8f6f4',
    200: '#b1eeea',
    300: '#89e5df',
    400: '#62ddd5',
    500: '#3bd4ca', // Main primary color
    600: '#2faaa2',
    700: '#237f79',
    800: '#185551',
    900: '#0c2a28',
  },

  // Brand Colors - Secondary (Dark Blue)
  secondary: {
    100: '#cfd1d4',
    200: '#9fa2aa',
    300: '#6f747f',
    400: '#3f4555',
    500: '#0f172a', // Main secondary color
    600: '#0c1222',
    700: '#090e19',
    800: '#060911',
    900: '#030508',
  },

  // Neutral - Gray Scale
  neutral: {
    100: '#f8f8f8',
    200: '#f1f1f1',
    300: '#eaeaea',
    400: '#e3e3e3',
    500: '#dcdcdc',
    600: '#b0b0b0',
    700: '#848484',
    800: '#585858',
    900: '#2c2c2c',
    white: '#ffffff',
    black: '#000000',
  },

  // Feedback - Success (Green)
  success: {
    100: '#e6f3e6',
    200: '#cde6cd',
    300: '#b5dab4',
    400: '#9ccd9b',
    500: '#83c182', // Main success color
    600: '#699a68',
    700: '#4f744e',
    800: '#344d34',
    900: '#1a271a',
  },

  // Feedback - Warning (Orange/Yellow)
  warning: {
    100: '#fdefd8',
    200: '#fbdfb2',
    300: '#facf8b',
    400: '#f8bf64',
    500: '#f5af3d', // Main warning color
    600: '#c58c31',
    700: '#946925',
    800: '#624619',
    900: '#31230c',
  },

  // Feedback - Error (Red)
  error: {
    100: '#ffdddc',
    200: '#ffbbb9',
    300: '#ff9996',
    400: '#ff7773',
    500: '#ff554f', // Main error color
    600: '#cc4440',
    700: '#993330',
    800: '#662220',
    900: '#331110',
  },

  // Features - Info (Blue)
  info: {
    100: '#dfeffb',
    200: '#c0e0f7',
    300: '#a0d0f4',
    400: '#81c1f0',
    500: '#61b1ec', // Main info color
    600: '#4e8ebd',
    700: '#3a6a8e',
    800: '#27475e',
    900: '#13232f',
  },

  // Features - Brandkit (Cyan)
  brandkit: {
    100: '#ddf4fc',
    200: '#bbe9f8',
    300: '#98ddf5',
    400: '#76d2f1',
    500: '#54c7ee',
    600: '#439fbe',
    700: '#32778f',
    800: '#22505f',
    900: '#112830',
  },
} as const;

export type ColorScale = keyof typeof colors;
export type ColorShade =
  | '100'
  | '200'
  | '300'
  | '400'
  | '500'
  | '600'
  | '700'
  | '800'
  | '900';
